<template>
	<ProgressSpinner v-if="!team"/>
	<Container class="pt-6" v-if="team">
		<div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">
			<PageHeading>{{ team.name ?? $route.params.team }}</PageHeading>
		</div>

		<div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 -px-8">
			<TabLayout :tabs="tabs" sticky/>
		</div>

		<router-view
				@on-save="$emit('on-save')"
				@on-delete="$emit('on-delete')"
				:team="team"
		></router-view>
	</Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import { mapStores } from "pinia";
import { useTeamsStore } from "@/stores/teams.js";
import Container from "@/Components/Container.vue";


export default {
	name: "TeamView",
	components: {Container, TabLayout, PageHeading},
	data() {
		return {
			team: undefined,
		}
	},
	emits: [
		'on-save',
		'on-delete',
	],
	watch: {
		'$route.params.team': {
			async handler(newValue, oldValue) {
				if(newValue){
					if(this.$route.params.team === 'NEW'){
						this.team = {};
					} else {
						this.team = await this.teamsStore.showTeam(this.$route.params.team);
					}
				} else {
					this.team = undefined;
				}
			},
			immediate: true,
		}
	},
	computed: {
		...mapStores(useTeamsStore),
		tabs() {
			return [
				{
					label: this.$t('pages.admin.users.teams.team.team_view.summary'),
					current: this.$route.name === 'admin.users.teams.team',
					to: {name: 'admin.users.teams.team', params: this.$route.params}
				},
				// {
				// 	name: 'Roles',
				// 	current: this.$route.name === 'admin.users.teams.roles',
				// 	to: {name: 'admin.users.teams.roles', params: this.$route.params}
				// },
			]
		}
	},
}
</script>